import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_OtherAmountView = _resolveComponent("OtherAmountView")!
  const _component_OtherAmountLegacyView = _resolveComponent("OtherAmountLegacyView")!

  return (!_ctx.ready)
    ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
    : (_ctx.useRedesign)
      ? (_openBlock(), _createBlock(_component_OtherAmountView, { key: 1 }))
      : (_openBlock(), _createBlock(_component_OtherAmountLegacyView, { key: 2 }))
}